<template>
  <div id="card-propiedades"   class="px-0 my-3 py-xl-0 py-3 justify-content-center"   > 
    <div  class="shadow_card   rounded-bottom bg-card px-0 card-div altura-card "   >
     <!-- {{ product }} -->
      <imgCard  :detailCardAgente="product" class=" "></imgCard>
      <detailCardAgent :detailCardAgente="product" :detail="true" class="p-4"></detailCardAgent>
     
    
    </div>

  </div>
</template>

<script>
import imgCard from "../components/ImgCardAgent.vue";
import detailCardAgent from "../components/detailCardAgent.vue";

export default {
  props: ["product"],
  components: {imgCard, detailCardAgent },
  data: () => ({
    className: "product",
    user: null
  }),
  mounted() {
    
  },
  methods:{
     
  }
};
</script>

<style lang="scss" scoped>
///////////////////////////////
  #card-propiedades{

  }
  #card-propiedades :hover h3{
    transition: all  0.2s ease; /* Transición suave para todos los cambios */

  // transition: all  0.7s ease; /* Transición suave para todos los cambios */

    color: var(--primary) !important;
  }
  
  .shadow_card {
    background: transparent;
    box-shadow: 0 .2rem .8rem rgba(0, 0, 0, 0.048)!important;
  }

  .rounded-card-right{
    border-top-right-radius: 10px;
  }
  .rounded-card-right-b{
    border-bottom-right-radius: 10px;
  }

.altura-card{
  height: 100% !important;
  width: 100% !important;
  display:inline-block;
}
.altura-card-detalle{
  height: 15rem !important;
  
}
.altura-card-detalle-propiedades{
  height: 12rem !important;
  
}
.altura-card-footer-propiedades{
  height: auto !important;
  
}
.altura-card-boton{
  height: 50px !important;
  margin-top: 35px;
  margin-left: 15px;
}


  .text-card1{
    height: 100px;
  }
  
  .text-card1 {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

/////////////////
$primary: rgba(255, 0, 119, 1);

.text-card{
  height: 70px;
}

.text-card {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}


.bg-image-card {

  // border-top-right-radius: 10px;
  background-color: #cccccc;
  height: 18rem;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.radius-border{
  border-top-right-radius: 15px !important;
}

.radius-border-left-bottton{
  border-bottom-right-radius: 15px !important;
}
h4 {
  color: $primary;
}

.product-alt {
  background: transparent;
  border: 1px solid $primary;
  border-radius: var(--radius);
  margin: 1rem;
  padding: 1rem;
  color: #fff;
}
.productimg{
  height:10rem; width:80%; display:block; margin:auto
}

@media screen and (max-width: 600px) {
  .productimg{
    height:10rem; width:50%; display:block; margin:auto
  }
}
</style>